/* global Intl */

function candidateZoneLabel(timeZone, instant) {
  const name = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' })
    .formatToParts(new Date(instant))
    .find(part => part.type === 'timeZoneName').value;
  if (/^[A-Za-z]+$/.test(name)) return name;
  return `${name} ${timeZone.split('/').pop().replace(/_/g, ' ')}`;
}

// eslint-disable-next-line import/prefer-default-export
export { candidateZoneLabel };
